module.exports = __webpack_public_path__ + "img/logo-barclays.5b26eb39.png";